module.exports = __webpack_public_path__ + "static/img/1.a438423.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/1.png
// module id = BoGl
// module chunks = 0